// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__B5QcP","clinicsSelect":"TableHeading_clinicsSelect__-rKjK"};